<div class="row animate__animated animate__fadeIn" *ngIf="!loading">

    <!-- Slides -->
    <div class="col-12 mt-5 mt-lg-5 px-0 animate__animated animate__fadeIn animate__delay-1s"
        *ngIf="moviesSlideshow.movies">
        <h1 class="titulo-felix text-white mb-3">FÉLIX OLIVER - EL LUGAR DEL CINE URUGUAYO</h1>
        <app-ui-slideshow [movies]="moviesSlideshow.movies"></app-ui-slideshow>
    </div>

    <!-- Banner de Felix Oliver -->
    <!-- <div class="col-12 mt-5 mt-lg-5 px-0 animate__animated animate__fadeIn animate__delay-1s" *ngIf="showFOBanner">
        <app-banner-felix-oliver></app-banner-felix-oliver>
    </div> -->

    <!-- Movies en grilla agrupadas por categoría -->
    <div class="col-12 mt-5 mt-lg-5 px-0  animate__animated animate__fadeIn animate__delay-2s contenedorPeliculas">
        <div *ngFor="let category of moviesPerCategories">
            <app-ui-movies-grid *ngIf="!category.category.isCarrusel" [movies]="category.movies"
                [title]="category.category.name" [felixoliver]="true">
            </app-ui-movies-grid>
            <app-ui-slides-carousel *ngIf="category.category.isCarrusel" [movies]="category.movies"
                [title]="category.category.name" [showInfo]="true" [felixoliver]="true">
            </app-ui-slides-carousel>
        </div>
    </div>

    <br>

</div>

<div class="loading_general">
    <img class="animate__animated animate__flash animate__infinite animate__slow "
        src="assets\img\logos_cinemateca\SVG\logo_completo_blanco.svg" alt="Cinemateca" />
</div>

<br />